import React from 'react';

import UserAccountForm from '../components/UserAccountForm';

function Registration(): JSX.Element {
    return <UserAccountForm variant="registration" />;
}

export default Registration;
